import { useCallback, useState } from "react";

export const getOsIcon = async (screens, id) => {
  const currentScreen = screens.find((x) => x.id === id);

  if (currentScreen) {
    console.log("getOsIcon: ", currentScreen.os_icon_file_name.toLowerCase());
    const module = await import(`../assets/images/os-${currentScreen.os_icon_file_name.toLowerCase()}.svg`);
    return module.default;
  }

  return null;
};

export const useOSIcons = (screens) => {
  const [osIcons, setOsIcons] = useState({});

  const fetchOsIcons = useCallback(
    async (screenItems) => {
      const iconPromises = (screenItems || []).map(async (screen) => {
        const icon = await getOsIcon(screens, screen.id);
        return { id: screen.id, icon };
      });

      const iconsArray = await Promise.all(iconPromises);
      const icons = iconsArray.reduce((acc, curr) => {
        acc[curr.id] = curr.icon;
        return acc;
      }, {});

      setOsIcons(icons);
    },
    [screens],
  );

  return { osIcons, fetchOsIcons };
};
